import ComponentBase from "../../public/component/component_base";
import AudioManager from "../../../manager/audio_manager";

const { ccclass, property } = cc._decorator;

@ccclass
export default class TableClock extends ComponentBase{

    @property(cc.Label)
    labelSecs: cc.Label = null

    @property(cc.Animation)
    anim: cc.Animation = null

    protected m_clockScheduleId: number = 0
    protected m_isShaking: boolean = false

    showClock(show: boolean, secs?: number, needShake?: boolean, onFinish?: Function, onTick?: Function){
        this.node.active = show
        this.m_isShaking = false
        if(this.m_clockScheduleId > 0){
            this.cancelSchedule(this.m_clockScheduleId)
            this.m_clockScheduleId = 0
        }
        if(show){            
            this.showClockShake(false)
            this.refreshClockLable(secs, needShake, onFinish, onTick)
        }
    }

    protected refreshClockLable(secs: number, needShake?: boolean, onFinish?: Function, onTick?: Function){
        let self = this
        this.labelSecs && (this.labelSecs.string = secs.toString())
        if(secs <= 0){
            if(needShake){
                AudioManager.instance.vibrate()
            }
            if(onFinish){
                onFinish()
            }
            return
        }
        this.m_clockScheduleId = this.doScheduleOnce(function(){
            self.m_clockScheduleId = 0
            secs--
            self.refreshClockLable(secs, needShake, onFinish, onTick)
            if(!self.m_isShaking){
                if(secs <= 4){
                    self.m_isShaking = true
                    self.showClockShake(true)
                }
            }
            onTick && onTick(secs)
        }, 1)
    }

    protected showClockShake(show: boolean, leftSecs?: number, totalShakeLen?: number){
        if(show){
            this.anim.play()
        }else{
            this.anim.setCurrentTime(0)
            this.anim.stop()            
        }  
    }
}